import { render, staticRenderFns } from "./Passwords.vue?vue&type=template&id=29e5da60&scoped=true"
import script from "./Passwords.vue?vue&type=script&lang=js"
export * from "./Passwords.vue?vue&type=script&lang=js"
import style0 from "./Passwords.vue?vue&type=style&index=0&id=29e5da60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e5da60",
  null
  
)

export default component.exports